{
    "v": "5.8.1",
    "fr": 30,
    "ip": 0,
    "op": 60,
    "w": 500,
    "h": 500,
    "nm": "04 Setting",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 3,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 0,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [0, 0, 0],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [50, 50, 0],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [100, 100, 100],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 24,
                                "ix": 1
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 1
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Setting",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [0.7],
                                "y": [1]
                            },
                            "o": {
                                "x": [0.3],
                                "y": [0]
                            },
                            "t": 0,
                            "s": [0]
                        },
                        {
                            "i": {
                                "x": [0.7],
                                "y": [1]
                            },
                            "o": {
                                "x": [0.3],
                                "y": [0]
                            },
                            "t": 17,
                            "s": [-69.131]
                        },
                        {
                            "t": 52,
                            "s": [180]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": 0.68,
                                "y": 1
                            },
                            "o": {
                                "x": 0.32,
                                "y": 0
                            },
                            "t": 0,
                            "s": [50, 50, 0],
                            "to": [-7.333, 0, 0],
                            "ti": [-6.667, 0, 0]
                        },
                        {
                            "i": {
                                "x": 0.68,
                                "y": 1
                            },
                            "o": {
                                "x": 0.32,
                                "y": 0
                            },
                            "t": 18,
                            "s": [6, 50, 0],
                            "to": [6.667, 0, 0],
                            "ti": [-7.333, 0, 0]
                        },
                        {
                            "i": {
                                "x": 0.68,
                                "y": 1
                            },
                            "o": {
                                "x": 0.32,
                                "y": 0
                            },
                            "t": 41,
                            "s": [90, 50, 0],
                            "to": [7.333, 0, 0],
                            "ti": [6.667, 0, 0]
                        },
                        {
                            "t": 57,
                            "s": [50, 50, 0]
                        }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [699.975, -0.036, 0],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [100, 100, 100],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [12.842, 8.092],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [3.295, 14.411],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-8.091, 12.842],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-14.411, 3.295],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-12.844, -8.091],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-3.295, -14.412],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [8.092, -12.844],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [14.412, -3.295],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [-14.412, -3.295],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-8.091, -12.844],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [3.295, -14.412],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [12.844, -8.091],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [14.411, 3.295],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [8.092, 12.842],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-3.294, 14.41],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-12.842, 8.092],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [672.692, 178.814],
                                        [672.692, 130.296],
                                        [670.337, 129.757],
                                        [629.263, 112.596],
                                        [627.215, 111.306],
                                        [592.8, 145.721],
                                        [554.217, 107.139],
                                        [588.631, 72.724],
                                        [587.341, 70.676],
                                        [570.182, 29.602],
                                        [569.643, 27.247],
                                        [521.125, 27.247],
                                        [521.125, -27.318],
                                        [569.643, -27.318],
                                        [570.182, -29.673],
                                        [587.342, -70.747],
                                        [588.633, -72.795],
                                        [554.217, -107.21],
                                        [592.8, -145.794],
                                        [627.215, -111.379],
                                        [629.262, -112.669],
                                        [670.337, -129.828],
                                        [672.692, -130.367],
                                        [672.692, -178.885],
                                        [727.257, -178.885],
                                        [727.257, -130.367],
                                        [729.612, -129.828],
                                        [770.687, -112.669],
                                        [772.735, -111.379],
                                        [807.149, -145.794],
                                        [845.733, -107.21],
                                        [811.316, -72.795],
                                        [812.607, -70.747],
                                        [829.767, -29.674],
                                        [830.306, -27.318],
                                        [878.825, -27.318],
                                        [878.825, 27.247],
                                        [830.306, 27.247],
                                        [829.767, 29.602],
                                        [812.608, 70.676],
                                        [811.318, 72.724],
                                        [845.733, 107.139],
                                        [807.149, 145.721],
                                        [772.735, 111.306],
                                        [770.686, 112.596],
                                        [729.612, 129.757],
                                        [727.257, 130.296],
                                        [727.257, 178.814]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [0, 0],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [0, 0],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [100, 100],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [33.437, 0],
                                                [0, 33.437],
                                                [-33.437, 0],
                                                [0, -33.437]
                                            ],
                                            "o": [
                                                [-33.437, 0],
                                                [0, -33.437],
                                                [33.437, 0],
                                                [0, 33.437]
                                            ],
                                            "v": [
                                                [699.975, 60.592],
                                                [639.348, -0.036],
                                                [699.975, -60.663],
                                                [760.602, -0.036]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [0, 0],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [0, 0],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [100, 100],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [0, 0],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [0, 0],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [100, 100],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Setting",
                    "np": 1,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 0,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [250, 250, 0],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [0, 0, 0],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [100, 100, 100],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
